/**
 * ReviewDashboardContainer
 *
 *
 */

import React, { useState, useEffect } from 'react';
import ReviewDashboardPresenter from './ReviewDashboardPresenter';
import MessageAlert from 'utils';
import { ReviewApi, StatisticsApi } from 'api';
import moment from 'moment';

const DAY = -30;
const MOMENT_FORMAT = 'YYYY-MM-DD';
const startDate = moment().add(DAY, 'days').format(MOMENT_FORMAT);
const endDate = moment().format(MOMENT_FORMAT);
const startDateUnix = moment().add(DAY, 'days').startOf().unix();
const endDateUnix = moment().endOf().unix();

/**----------------------------------------
 * [Component] 총관리자: 장바구니 분석 - 컨테이너
 * ----------------------------------------
 */
const ReviewDashboardContainer = ({ defaultShopId, permission }) => {
  /* ===== INIT ===== */
  /* ===== STATE ===== */
  const [currentShop, _setCurrentShop] = useState(defaultShopId ?? null);
  const [loading, setLoading] = useState(false);
  const [reviewData, setReviewData] = useState(null);
  const [reviewList, setReviewList] = useState(null);
  /* ===== VARIABLE ===== */

  /* ===== FUNCTION ===== */
  /**--------------------
   * 상품 데이터 조회
   * --------------------
   */
  const getReviewData = async () => {
    setLoading(true);
    try {
      const { status, message, data } = await StatisticsApi.getStatistics(
        `review-dashboard`,
        {
          endDate,
          startDate,
          ...(currentShop && { shopId: currentShop }),
        }
      );
      if (status !== 200) throw { message };

      setReviewData(data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log('[UserDashboardContainer][getReviewData] Error: ', e);
      MessageAlert.error(e.message);
    }
  };

  /**--------------------
   * 리뷰목록 조회
   * --------------------
   */
  const getReviewList = async () => {
    try {
      const { status, message, data } = await ReviewApi.getReviews({
        join_tables: `["user", "product", "review_file", "point_history"]`,
        start_date: startDateUnix,
        end_date: endDateUnix,
        // shop_information_id: currentShop,
        ...(currentShop && { shop_information_id: currentShop }),
      });
      if (status !== 200) throw { message };
      // console.log('[getReviewList] data: ', data);
      const newData = data?.map((review) => ({
        key: review?.review_id,
        ...review,
        point_history: review?.point_history?.length
          ? review?.point_history?.[0]
          : null,
      }));
      setReviewList(newData);
    } catch (e) {
      MessageAlert.error(e.message);
    }
  };

  /* ===== HOOKS ===== */
  useEffect(() => {
    getReviewData();
    getReviewList();
  }, []);

  /* ===== RENDER ===== */
  const props = {
    loading,
    permission,
    reviewData,
    reviewList,
  };
  // JSX: start
  return (
    <>
      <ReviewDashboardPresenter {...props} />
    </>
  ); // JSX: end
};

ReviewDashboardContainer.defaultProps = {
  defaultShopId: null,
  permission: 'ADMIN',
};
export default ReviewDashboardContainer;
